<template>
  <hm-content>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="product-ruleForm"
    >
      <el-form-item label="品牌名称：" prop="brandName">
        <el-input
          :disabled="disabled"
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.brandName"
          placeholder="请输入品牌名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="品牌首字母：" prop="brandAcronym">
        <el-input
          :disabled="disabled"
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.brandAcronym"
          placeholder="请一个输入品牌大写英文首字母"
        ></el-input>
      </el-form-item>
      <el-form-item label="品牌LOGO：" prop="brandLogo">
        <my-upload
          field="file"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccess"
          @crop-upload-fail="cropUploadFail"
          v-model="show"
          noCircle
          noSquare
          :width="400"
          :height="400"
          :headers="{ 'X-Access-Token': $token }"
          :params="{ fileDir: 'mall' }"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload>
        <el-button
          :disabled="disabled"
          type="primary"
          size="small"
          v-show="!listHeaderImgUrl"
          @click="toggleShow"
          >点击上传</el-button
        >
        <span class="form-tip"
          >只能上传jpg/png文件，且不能超过1MB，建议图片尺寸为400x400像素的png图(最多上传一张）</span
        >
        <div class="priview" v-if="listHeaderImgUrl">
          <img :src="listHeaderImgUrl" alt="主图" />
          <div class="opreat-wrapper flex item-center flex-center">
            <el-button :disabled="disabled" type="text" @click="handleRemove"
              >删除</el-button
            >
          </div>
        </div>
      </el-form-item>
      <el-form-item label="排序：" prop="seqNum">
        <el-input
          :disabled="disabled"
          size="small"
          clearable
          class="mr10 ipt"
          type="number"
          v-model.trim="ruleForm.seqNum"
          placeholder="数字越大，排序越靠前，0为默认值"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否显示" prop="isSalesEndDisplay">
        <el-switch
          active-value="true"
          inactive-value="false"
          :disabled="disabled"
          v-model="ruleForm.isSalesEndDisplay"
        ></el-switch>
        <span class="form-tip">手机端品牌筛选是否显示</span>
      </el-form-item>
      <el-form-item label="品牌起源地：" prop="brandOrigin">
        <el-input
          :disabled="disabled"
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.brandOrigin"
          placeholder="请输入一行文本，限制30个字符"
        ></el-input>
      </el-form-item>
      <el-form-item label="实际产地：" prop="realOrigin">
        <el-input
          :disabled="disabled"
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.realOrigin"
          placeholder="请输入一行文本，限制30个字符"
        ></el-input>
      </el-form-item>
      <el-form-item label="品牌故事" prop="brandStory">
        <el-input
          :disabled="disabled"
          style="width:500px"
          type="textarea"
          v-model="ruleForm.brandStory"
          placeholder="品牌故事500字以内"
        ></el-input>
      </el-form-item>
      <div class="flex flex-center">
        <el-button
          type="primary"
          v-if="!disabled"
          size="small"
          @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button size="small" @click="$router.back(-1)">返回</el-button>
      </div>
    </el-form>
  </hm-content>
</template>
<script>
import myUpload from "vue-image-crop-upload";
export default {
  components: { myUpload },
  data() {
    const patternLocation = function(rule, val, callback) {
      let haveEmptyCondition = false;

      const reg = /^[A-Z]+$/;
      if (!reg.test(val)) {
        haveEmptyCondition = true;
      }
      if (haveEmptyCondition) {
        return callback(new Error("请输入一个大写英文字母"));
      }
      callback();
    }.bind(this);
    return {
      disabled: "",
      show: false,
      listHeaderImgUrl: "",
      ruleForm: {
        brandName: "",
        brandAcronym: "",
        seqNum: "",
        brandOrigin: "",
        realOrigin: "",
        brandStory: "",
        isSalesEndDisplay: true
      },
      rules: {
        brandName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 2, message: "长度不能小于2个字符", trigger: "blur" },
          { max: 20, message: "长度在20个字符内", trigger: "blur" }
        ],
        seqNum: [
          {
            max: 6,
            message: "长度在6个字符内",
            trigger: "blur",
            pattern: /^\d{1,6}$/
          }
        ],
        brandAcronym: [
          { max: 1, message: "请输入一个大写英文字母", trigger: "blur" },
          {
            required: true,
            validator: patternLocation,
            trigger: "blur"
          }
        ],
        brandOrigin: [
          { max: 30, message: "长度在30个字符内", trigger: "blur" }
        ],
        realOrigin: [{ max: 30, message: "长度在30个字符内", trigger: "blur" }],
        brandStory: [
          { max: 500, message: "长度在500个字符内", trigger: "blur" }
        ]
      }
    };
  },
  created() {},
  mounted() {
    this.disabled = true;
    this.brandDetail().then(res => {
      this.listHeaderImgUrl = res.result.brandLogo;
      for (let key in res.result) {
        this.ruleForm[key] = res.result[key];
      }
    });
  },
  methods: {
    brandDetail() {
      const { brandId } = this.$route.query;
      const params = {
        brandId
      };
      return this.$store.dispatch("queryBrandDetail", params);
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    // 移除上传文件
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          params.seqNum = this.ruleForm.seqNum || 0;
          params = Object.assign(params, {
            brandLogo: this.listHeaderImgUrl
          });
          params = Object.assign(params, {
            brandLogo: this.listHeaderImgUrl
          });
          this.$store.dispatch("addBrandActivity", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.priview {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
